import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchContactTasksParams {
	readonly contactId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchContactTasksApiQuery extends ApiQuery<
	TaskOutput[],
	FetchContactTasksParams
> {
	client = 'iam';
	document = gql`
		query FetchContactTasks($contactId: UUID!) {
			fetchContactTasks(contactId: $contactId) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchContactTasks';
}
